import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withData } from './data';

import { NewsSourceTagAutocompleteUI } from './ui';

export class NewsSourceTagAutocomplete extends PureComponent {
    static displayName = 'NewsSourceTagAutocompleteContainer';

    static propTypes = {
        styles: PropTypes.objectOf(PropTypes.any),
        options: PropTypes.arrayOf(PropTypes.object),
        initialSearchTerm: PropTypes.string,
        label: PropTypes.string,
        loading: PropTypes.bool,
        name: PropTypes.string,
        onChange: PropTypes.func,
        placeholder: PropTypes.string,
        value: PropTypes.string
    };

    static defaultProps = {
        styles: undefined,
        options: [],
        initialSearchTerm: null,
        label: null,
        loading: false,
        name: 'newsSourceTagAutocomplete',
        onChange: null,
        placeholder: 'Filter by News Tag',
        value: null
    };

    render() {
        const { styles, options, initialSearchTerm, label, loading, name, onChange, placeholder, value } = this.props;
        return (
            <NewsSourceTagAutocompleteUI
                styles={styles}
                options={options}
                initialSearchTerm={initialSearchTerm}
                label={label}
                loading={loading}
                name={name}
                onChange={onChange}
                placeholder={placeholder}
                value={value}
            />
        );
    }
}

export const NewsSourceTagAutocompleteContainer = compose(withData())(NewsSourceTagAutocomplete);
